//import { defineCustomElement } from 'vue'


import WeatherMapAi from './components/WeatherMapAi.vue';
//import WeatherCherryPicker from './components/WeatherCherryPicker.vue';
import WeatherExceptionTracker from './components/weatherexceptions/WeatherExceptionTracker.vue';
import { ConcretePourTracker, ShippingWeatherTracker, MultiRouteShippingTracker, FlexibleWeatherTracker } from './components/weatherexceptions/industry';
import ModelComparison from './components/ModelComparison.vue';
import ModelLoadStatus from './components/ModelLoadStatus.vue';
import SevereWeatherAnalyzer from './components/SevereWeatherAnalyzer.vue';
import ForecastAccuracyTracker from './components/forecastaccuracy/ForecastAccuracyTracker.vue';
import { setGlobalServerRoot } from './components/weatherexceptions/apiConfig.js';

// Import our custom CSS
import './scss/styles.scss'
import './wxwidgets/wxwidgets.scss'

// ---- DEV SERVER CONFIGURATION ----
// Set the backend server for all dev components
// Change this URL to point to your local or test server
const DEV_SERVER_ROOT = 'https://weather6.visualcrossing.com/';
setGlobalServerRoot(DEV_SERVER_ROOT);
console.log(`[Dev] Using server root: ${DEV_SERVER_ROOT}`);



//import { createApp } from 'vue'

//export { createApp, WeatherSummary2Component };

//createApp(WeatherSummary2Component).mount('#app')


let VcComponentLoader = (function(){
    console.log("Starting VcDevComponentLoader..." );
    const COMPONENTS={
       
        'WeatherMapAi':WeatherMapAi,
        //'WeatherCherryPicker':WeatherCherryPicker,
        'WeatherExceptionTracker': WeatherExceptionTracker,
        'ConcretePourTracker': ConcretePourTracker,
        'ShippingWeatherTracker': ShippingWeatherTracker,
        'MultiRouteShippingTracker': MultiRouteShippingTracker,
        'FlexibleWeatherTracker': FlexibleWeatherTracker,
        'ModelComparison': ModelComparison,
        'ModelLoadStatus': ModelLoadStatus,
        'SevereWeatherAnalyzer': SevereWeatherAnalyzer,
        'ForecastAccuracyTracker': ForecastAccuracyTracker,
        
    };

    window.VcAvailableComponents=(window.VcAvailableComponents && { ...window.VcAvailableComponents, ...COMPONENTS }) || COMPONENTS;
    /*
    let isReady=false;

    window.addEventListener("load",function(event) {
        isReady=true;

        attachComponents();
        
    },false);
   
    function attachComponents() {
        if (!window.VcComponents) {
            console.log("No VcComponents found..." );
            return;
        }

        window.VcComponents.forEach(item => {
            if (!COMPONENTS[item.component]) {
                console.log("Component not found..." +item.component);
                return;
            }
            console.log("Component being mounted..." +item.component);
            createApp(COMPONENTS[item.component]).mount(item.selector)
        });
    }*/
})();



